var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('SanityContent',{staticClass:"block-content",attrs:{"blocks":_vm.blocks,"serializers":_vm.mergedSerializers}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }